module.exports = __webpack_public_path__ + "img/pogodin.a5d07b7d.png";